const MojeO2AppBannerDesktopLink = 'https://moje.o2.cz/document-direct/?path=o2%2FMojeO2App-Desktop.jpg&site=o2';

export default MojeO2AppBannerDesktopLink;
